import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "input", "recents"]

  connect() {
    this.onKeydown = this._onKeydown.bind(this)
    this._onBackdropClick = this._handleBackdropClick.bind(this)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  open() {
    this.element.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    if (this.hasInputTarget) {
      setTimeout(() => this.inputTarget.focus(), 50)
    }
    this._renderRecents()
    // Listen for taps on the backdrop area
    requestAnimationFrame(() => {
      this.element.addEventListener("click", this._onBackdropClick)
    })
  }

  close() {
    this.element.classList.add("hidden")
    document.body.style.overflow = ""
    this.element.removeEventListener("click", this._onBackdropClick)
  }

  submit(event) {
    event.preventDefault()
    const query = this.inputTarget.value.trim()
    if (!query) return

    this._saveRecent(query)
    window.location.href = `/search?q=${encodeURIComponent(query)}`
  }

  clearRecents() {
    localStorage.removeItem("mc_recent_searches")
    this._renderRecents()
  }

  _handleBackdropClick(event) {
    // Close if tap is on the outer container itself (the backdrop), not on inner content
    if (event.target === this.element) {
      this.close()
    }
  }

  _onKeydown(event) {
    if (event.key === "Escape" && !this.element.classList.contains("hidden")) {
      this.close()
    }
  }

  _saveRecent(query) {
    let recents = JSON.parse(localStorage.getItem("mc_recent_searches") || "[]")
    recents = recents.filter(r => r !== query)
    recents.unshift(query)
    if (recents.length > 5) recents = recents.slice(0, 5)
    localStorage.setItem("mc_recent_searches", JSON.stringify(recents))
  }

  _renderRecents() {
    if (!this.hasRecentsTarget) return
    const recents = JSON.parse(localStorage.getItem("mc_recent_searches") || "[]")
    if (recents.length === 0) {
      this.recentsTarget.innerHTML = '<p class="fs-empty">No recent searches</p>'
      return
    }
    this.recentsTarget.innerHTML = recents.map(r =>
      `<a href="/search?q=${encodeURIComponent(r)}" class="fs-recent-item">
        <i class="fas fa-clock"></i>
        <span>${this._escapeHtml(r)}</span>
      </a>`
    ).join("") + `<button class="fs-clear-recents" data-action="click->fullscreen-search#clearRecents">Clear All</button>`
  }

  _escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
